import type { IStorageService } from '@/interfaces'

class LocalStorageService implements IStorageService {
  itemName: string

  itemValue: string

  constructor() {
    this.itemName = ''
    this.itemValue = ''
  }

  public getData(itemName: string) {
    this.itemName = itemName

    try {
      return localStorage.getItem(this.itemName)
    } catch (e) {
      throw new Error(`Failed to get item ${this.itemName}: ${e}`)
    }
  }

  public setData(itemName: string, itemValue: string) {
    this.itemName = itemName
    this.itemValue = itemValue

    try {
      localStorage.setItem(this.itemName, this.itemValue)
    } catch (e) {
      throw new Error(`Failed to set item ${this.itemName}: ${e}`)
    }
  }

  public updateData(itemName: string, itemValue: string) {
    this.itemName = itemName
    this.itemValue = itemValue

    try {
      localStorage.setItem(this.itemName, this.itemValue)
    } catch (e) {
      throw new Error(`Failed to update item ${this.itemName}: ${e}`)
    }
  }

  public removeData(itemName: string) {
    this.itemName = itemName

    try {
      localStorage.removeItem(this.itemName)
    } catch (e) {
      throw new Error(`Failed to remove item ${this.itemValue}: ${e}`)
    }
  }

  public checkData(itemName: string, itemValue: string) {
    this.itemName = itemName
    this.itemValue = itemValue

    try {
      return this.getData(this.itemName) === itemValue
    } catch (e) {
      throw new Error(`Failed to check item ${itemName}: ${e}`)
    }
  }

  public clearLocalStorage() {
    this.itemName = ''
    this.itemValue = ''
    localStorage.clear()
  }
}

export default LocalStorageService
